import React, {Component} from 'react';
import App from "../../App";
import {Link, withRouter} from "react-router-dom";
import {MdArrowBack} from "react-icons/all";
import Commisson from './FcCommisson';
import { getDetails } from "../../services/baseServices";

class Details extends Component {
    state = {
        details: {},
    }

    componentDidMount() {
        getDetails("distributors", this.props.match.params.id)
        .then((res) => {
            this.setState({ details: res });
        })
        .catch((errMsg) => {
            console.log("Error Message: ", errMsg);
        });
    }

    render() {
        const {details} = this.state;

        return (
            <App layout={`boxed`}>
                <div className="main-content">
                <div className="page-header">
                    <div className="page-title"/>
                    <div className="ml-auto">
                    <Link to={`/dh/list`} className={`btn btn-sm btn-link`}><MdArrowBack/> Back
                        to List</Link>
                    </div>
                </div>

                <div className="card-block">
                    <div className="block-header">
                    <h4 className="block-title">Distribution House Details</h4>
                    </div>
                    <div className="block-body">
                    <>
                        <table className="info-table">
                        <tbody>
                        <tr>
                            <td style={{width: '250px'}}>Distributor Code</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td className={`text-bold`}>{details.code}</td>
                        </tr>
                        <tr>
                            <td style={{width: '250px'}}>Distributor Name</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td className={`text-bold`}>{details.name}</td>
                        </tr>
                        <tr>
                            <td style={{width: '250px'}}>Distributor Name in Bangla</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td>{details.bn_name}</td>
                        </tr>
                        <tr>
                            <td style={{width: '250px'}}>Email</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td>{details.email}</td>
                        </tr>
                        <tr>
                            <td style={{width: '250px'}}>Phone</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td>{details.phone}</td>
                        </tr>
                        {/* <tr>
                            <td style={{width: '250px'}}>Address</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td>{details.address?.area_name},{details.address?.thana_name},{details.address?.district_name}</td>
                        </tr> */}
                        <tr>
                            <td style={{width: '250px'}}>Status</td>
                            <td style={{width: '20px', textAlign: 'center'}}>:</td>
                            <td>{details.status}</td>
                        </tr> 
                        </tbody>
                        </table>
                    </>
                    </div>
                </div>

                <Commisson distributor={this.state.details}/>
                </div>
            </App>
        );
    }
}

export default withRouter(Details);